<template>
    <transition name="fade">
        <div v-if="active" class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                ></span
                >&#8203;

                <div
                    class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                >
                    <div class="bg-white">
                        <div class="sm:flex sm:flex-row sm:items-start">
                            <div
                                class="mt-3 text-center sm:mt-0 sm:text-left px-4 py-5 self-center bg-gray-200"
                                style="flex: 3;"
                            >
                                <div class="mt-2">
                                    <img class="mx-auto" loading="lazy" :src=src :alt="file.alt"/>
                                </div>
                            </div>

                            <div
                                class="justify-between self-stretch flex flex-col bg-gray-50 shadow-inner w-full md:max-w-lg flex-1 px-2 py-3">
                                <div>
                                    <p class="text-gray-500 mt-2 text-sm">
                                        File Type
                                    </p>

                                    <p class="text-gray-800 mt-1">
                                        {{ file.mime_type }}
                                    </p>

                                    <editable-field
                                        wrap-type="break-words"
                                        title="Alt"
                                        v-model.lazy="file.alt"
                                        :disabled="!editable"
                                        @input="isDirty = true"
                                        :errors="errors?.alt"
                                    ></editable-field>

                                    <editable-field
                                        wrap-type="break-words"
                                        title="File Name"
                                        class="mt-2"
                                        :disabled="!editable"
                                        v-model.lazy="file.file_name"
                                        @input="isDirty = true"
                                        :errors="errors?.file_name"
                                    ></editable-field>

                                    <editable-field
                                        wrap-type="break-words"
                                        title="Url"
                                        class="mt-2"
                                        :disabled="true"
                                        :value="urlBase + file.file_name"
                                        @input="isDirty = true"
                                    ></editable-field>

                                    <editable-field
                                        wrap-type="break-words"
                                        title="Long Description"
                                        class="mt-2"
                                        :disabled="!editable"
                                        v-model="file.long_description"
                                        @input="isDirty = true"
                                        :errors="errors?.long_description"
                                    ></editable-field>

                                    <div v-if="file?.type_id != 2">
                                        <input-checkbox
                                            name="use_color"
                                            v-model="file.use_color"
                                            label="Use Background Color?"
                                            label-class="text-gray-500 items-center text-sm"
                                            class="mt-2 w-5/6 py-0 px-0 block border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                            @change="onChangeUseColor"
                                        />

                                        <div class="flex flex-row text-gray-500 items-center mt-2">
                                            <p class="text-sm">Background Color</p>
                                        </div>

                                        <input-colour
                                            :disabled="Number(file.use_color) !== 1"
                                            name="color"
                                            class="mt-2 w-5/6 py-0 px-0 block border-gray-300 rounded-md focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                            v-model="file.color"
                                            @input="isDirty = true"
                                        />

                                        <div class="text-red-400 text-sm" v-if="errors?.color">
                                            {{ errors?.color?.join(', ')}}
                                        </div>
                                    </div>

                                    <editable-field
                                        title="File Size"
                                        class="mt-2"
                                        :disabled="true"
                                        :value="file.file_size / 1000 + 'Kb'"
                                        @input="isDirty = true"
                                    ></editable-field>
                                </div>

                                <div class="px-2 py-3 sm:flex sm:flex-row-reverse sm:justify-start">
                                    <span
                                        v-if="!isDirty && editable"
                                        class="flex rounded-md shadow-sm sm:ml-3 sm:w-auto"
                                    >
                                        <button
                                            @click="() => {
                                                return $emit('deleted', file)
                                            }"
                                            type="button"
                                            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:ring-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                        >
                                            Delete
                                        </button>
                                    </span>

                                    <span
                                        v-if="isDirty"
                                        class="flex rounded-md shadow-sm sm:ml-3 sm:w-auto"
                                    >
                                        <button
                                            @click="sendUpdate"
                                            type="button"
                                            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                        >
                                            Update
                                        </button>
                                    </span>

                                    <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                                        <button
                                            @click.prevent="closeModal"
                                            type="button"
                                            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue-200 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                        >
                                            Cancel
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'media-modal',
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        editable: {
            type: Boolean,
            default: true,
        },
        file: Object,
        editing: '',
    },
    data() {
        return {
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute('content'),
            isModalOpen: false,
            isDirty: false,
            errors: {},
        }
    },
    methods: {
        async sendUpdate() {
            await axios.patch(route('api.media.update', {media: this.file.id}), this.file)
                .then((response) => {
                    this.closeModal()
                })
                .catch(err => {
                    console.log(err?.response?.data || err)
                    this.errors = (err?.response?.data || err).errors;
                });
        },
        closeModal() {
            this.isDirty = false

            this.$emit('close', this.file)
        },
        onChangeUseColor (value) {
            if (Number(value) === 0) {
                this.file.color = null;
            }
            this.isDirty = true;
        },
    },
    computed: {
        src() {
            return this.file?.url + '?' + new Date().getTime()
        },
        urlBase() {
            const url = this.file?.url

            return url?.substring(0, url.lastIndexOf('/') + 1)
        },
    },
    watch: {
        file() {
            if (this.file && !this.file.use_color && !this.file.color) {
                this.file.use_color = 0;
                this.file.color = null;
            }
        },
    }
}
</script>
